import PageRequest from '../../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель запроса списка статусов очередей по фильтрам
 */
export default class GetStatusesListDetailRequest  {
	/**
	 * * Строка поиска
	 */
	Search!: string;
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	/**
	 * * Номер очереди задач
	 */
	QueueTaskId?: string;
	/**
	 * * Список номеров очередей задач
	 */
	QueueTaskIds!: Array<string>;
	/**
	 * * Номер рабочей области
	 */
	NamespaceId?: string;
	/**
	 * * Список рабочих областей
	 */
	NamespaceIds!: Array<string>;
	/**
	 * * Номер группы
	 */
	GroupId?: number;
	/**
	 * * Номер проекта
	 */
	ProjectId?: number;
	/**
	 * * Сортировка по названию
	 */
	OrderByName?: boolean = false;
	constructor(obj?: Partial<GetStatusesListDetailRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
